import { SERVER_URL } from '../managers/network';
import validator from 'validator';

export const getCookie = (cname) => {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export const eraseCookie = (name) => {
  document.cookie = name + '=; Max-Age=-99999999;';
};


export function getToken() {
  return getCookie('authtoken') || localStorage.getItem('token');
}



export function httpsUrlValidator(url){
  return validator.isURL(url,{
    protocols:['https'],
    require_protocol: false
  })
}

export function logout(){
  localStorage.removeItem("token")
  window.location.href = SERVER_URL + '/auth/logout'
}

export function removeScheme(url){
  return url.split("//").pop()
 }